<template>
  <div class="gallery">
    <iframe
      aria-label="Instagram feed"
      src="https://lightwidget.com/widgets/902a907e7c795be79c06250f95ecb1af.html"
      scrolling="no"
      allowtransparency="true"
      class="lightwidget-widget"
      style="width:100%;border:0;overflow:hidden;"
    ></iframe>
  </div>
</template>


<script>
export default {
  name: "gallery"
}
</script>

<style scoped>
.gallery {
  line-height: 0;
  margin-top: 5rem;
}
</style>
